export function basedOnCommandConsole({command}){
  console.log(command);
}